import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { BcInfo, PaginationDTO } from './general';

export interface Group {
  id: string;
  name: string;
  source: GroupSource;
  browsingCriteria: BcInfo;
  contactInfo: ContactInfo;
  creationDateTime: string;
  seUserRole: SupportedUserRoles;
  assigned: Assignee[] | null;
  agentOfRecord: Assignee | null;
  accountRepresentative: AccountRepresentative | null;
  lastUpdateTime: string;
  archived: boolean;
  additionalAORs: RenewalAgentOfRecord[];
  additionalContactInfos: ContactInfo[];
  carrierGroupNumber?: string;
  notes?: string;
}

export interface BiGroup extends Group {
  agency: Agency;
  agentOfRecord: RenewalAgentOfRecord;
}

export interface RenewalAgentOfRecord extends Assignee {
  email: string;
  firstName: string;
  lastName: string;
}

export interface Agency {
  id: string;
  name: string;
}
export interface Address {
  city?: string;
  street?: string;
  zip?: string;
  state?: string;
  street2?: string;
  county?: string;
}

export interface ContactInfo {
  firstName?: string;
  lastName?: string;
  primaryPhone?: string;
  primaryEmail?: string;
  primaryAddress: Address;
  title?: string;
}

export interface AccountRepresentative {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface Assignee {
  id: string;
  name: string;
  type: AssigneeType;
  email?: string;
  npn?: string;
  tin?: string;
}

export interface InputGroup {
  id: string;
  name: string;
  source: string;
  effectiveDate: string;
  carrierGroupNumber?: string;
  contactInfo: InputContactInfo;
  notes?: string;
  agentOfRecord: InputAgentOfRecord | null;
  accountRepresentative: AccountRepresentative | null;
}

export type InputAgentOfRecord = {
  id: string;
  name: string;
  npn?: string;
  tin?: string;
};

export type InputAssignee = {
  id: string;
  name: string;
  npn?: string;
  tin?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};

export interface InputAddress {
  city?: string;
  street?: string;
  street2?: string;
  zip?: string;
  state?: string;
  county?: string;
}

export interface InputContactInfo {
  firstName?: string;
  lastName?: string;
  primaryPhone?: string;
  primaryEmail?: string;
  title?: string;
  primaryAddress: InputAddress;
}

export interface GroupSearchReturnType {
  id: string;
  name: string;
  canAccess: boolean;
}

export interface GroupPageParams {
  sortBy: GroupSortBy;
  sortOrder: SortOrder;
  filter: GroupFilter;
  page: number;
  fullView: boolean;
}

export type GroupsPaginationDTO = PaginationDTO<Group>;

export interface BiDashboardFilter {
  filter: GroupFilter;
  name: string;
  effectiveDate: string;
  agencyId: string;
  fullView: boolean;
  assignedGroups: boolean;
  createdByMe: boolean;
  state: string;
  carrierGroupNumber: string;
  [key: string]: unknown;
}

export interface BiGroupPageParams extends BiDashboardFilter {
  sortBy: GroupSortBy;
  sortOrder: SortOrder;
  page: number;
}

export type BiGroupsPaginationDTO = PaginationDTO<BiGroup>;

export enum GroupSource {
  ESTORE = 'ESTORE',
  AGENT_V2 = 'AGENT_V2',
  SYNC = 'SYNC',
  PICK_CARRIERS = 'PICK_CARRIERS',
  /**
   * @deprecated
   */
  AGENT = 'AGENT',
}

export enum AssigneeType {
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  AGENT = 'AGENT',
  TEAM = 'TEAM',
}

// sort block
export enum GroupSortBy {
  UPDATE_TIME = 'UPDATE_TIME',
  NAME = 'NAME',
  EFFECTIVE_DATE = 'EFFECTIVE_DATE',
  STATE = 'STATE',
  CARRIER_GROUP_NUMBER = 'CARRIER_GROUP_NUMBER',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum GroupFilter {
  ALL = 'ALL',
  NEW_LEAD = 'NEW_LEAD',
  QUOTING = 'QUOTING',
  ENROLLING = 'ENROLLING',
  SUBMITTED = 'SUBMITTED',
  RENEWAL = 'RENEWAL',
  SOLD = 'SOLD',
  ARCHIVED = 'ARCHIVED',
  DORMANT = 'DORMANT',
}

export type FilterTitleObject<T extends string> = Readonly<{
  [key in T]: string;
}>;
